import { render, staticRenderFns } from "./Device.vue?vue&type=template&id=36b3aada"
import script from "./Device.vue?vue&type=script&lang=ts"
export * from "./Device.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports